import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import { Row as AriaRow, Collection, RowProps } from "react-aria-components";

export function Row<T extends object>({
  id,
  columns,
  children,
  ...otherProps
}: RowProps<T>) {
  return (
    <AriaRow
      id={id}
      {...mergeProps(otherProps, {
        className: css(styles.row),
      })}
    >
      <Collection items={columns}>{children}</Collection>
    </AriaRow>
  );
}

const styles = {
  row: css({
    outline: "none",
    "&[data-focused]": {
      boxShadow: "var(--focus-action)",
    },
    "&[data-hovered]": {
      backgroundColor: "var(--background-ghost-hover)",
    },
    "&[data-selected]": {
      backgroundColor: "var(--background-ghost-hover)",
    },
  }),
  checkboxCell: css({
    paddingLeft: "var(--space-2)",
    paddingRight: "var(--space-1)",
  }),
};
